import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useResolution886ReportFile } from '@/context/Resolution886ReportFiles';
import * as S from './styles';

const { useWatch } = Form;

interface CounterProps {
	total?: number;
}

export function Counter({ total = 0 }: Readonly<CounterProps>) {
	const selectedFiles = useWatch('file_list_id') || [];
	const { deselectedFiles, isSelectAllChecked } = useResolution886ReportFile();

	function handleGetTotalSelected(): number {
		if (isSelectAllChecked) {
			const totalDeselected = deselectedFiles?.size || 0;
			return total - totalDeselected;
		}

		return selectedFiles.length;
	}

	return (
		<S.CounterText>
			{handleGetTotalSelected()} {I18n.get('Selected')}
		</S.CounterText>
	);
}
